(function () {
  if (window.__srlVisumoIgniter) return;
  window.__srlVisumoIgniter = true;

  var SRC = 'https://tagdelivery.visumo.io/igniter.js';
  var loaded = false;

  function hasIgniter() {
    return !!document.querySelector('script[src="' + SRC + '"]');
  }

  function loadIgniter() {
    if (loaded || hasIgniter()) {
      loaded = true;
      return;
    }
    loaded = true;
    var script = document.createElement('script');
    script.src = SRC;
    script.defer = true;
    document.head.appendChild(script);
  }

  function observe() {
    if (window.Shopify && window.Shopify.designMode) {
      loadIgniter();
      return;
    }

    var sentinels = document.querySelectorAll('[data-visumo-lazy-root]');
    if (!sentinels.length) return;

    var eager = false;
    for (var k = 0; k < sentinels.length; k++) {
      if (sentinels[k].getAttribute('data-visumo-load') === 'eager') eager = true;
    }
    if (eager || typeof IntersectionObserver !== 'function') {
      loadIgniter();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          loadIgniter();
          observer.disconnect();
          break;
        }
      }
    }, { rootMargin: '200px 0px' });

    for (var j = 0; j < sentinels.length; j++) {
      observer.observe(sentinels[j]);
    }
  }

  // defer 実行中は readyState が interactive で、商品 ID の input はまだ無い。
  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
